import { render, staticRenderFns } from "./name-status.vue?vue&type=template&id=07784e02&scoped=true&"
import script from "./name-status.vue?vue&type=script&lang=ts&"
export * from "./name-status.vue?vue&type=script&lang=ts&"
import style0 from "./name-status.vue?vue&type=style&index=0&id=07784e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07784e02",
  null
  
)

export default component.exports